"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchDafProviders = exports.getDafProvider = exports.OTHER_DAF_PROVIDER = exports.DEFAULT_DAF_PROVIDERS = exports.DAF_PROVIDERS = void 0;
const daf_provider_directory_json_1 = __importDefault(require("./daf-provider-directory.json"));
exports.DAF_PROVIDERS = daf_provider_directory_json_1.default.map((provider) => ({
    ...provider,
    dafDirect: provider.id === "fidelity" || provider.id === "bny" || provider.id === "dafgiving360" ? provider.id : undefined,
}));
exports.DEFAULT_DAF_PROVIDERS = ["fidelity", "bny", "dafgiving360"].map((id) => exports.DAF_PROVIDERS.find((provider) => provider.id === id));
exports.OTHER_DAF_PROVIDER = { id: "other", name: "Other" };
const getDafProvider = (id) => id === exports.OTHER_DAF_PROVIDER.id ? exports.OTHER_DAF_PROVIDER : exports.DAF_PROVIDERS.find((provider) => provider.id === id);
exports.getDafProvider = getDafProvider;
const searchDafProviders = (search) => {
    const query = normalizeProviderName(search.trim());
    if (!query) {
        return [...exports.DEFAULT_DAF_PROVIDERS, ...exports.DAF_PROVIDERS.filter((provider) => !provider.dafDirect)];
    }
    return exports.DAF_PROVIDERS.map((provider) => {
        const names = [provider.name, ...(provider.aliases ?? [])].map(normalizeProviderName);
        const score = Math.min(...names.map((name) => {
            if (name === query) {
                return 0;
            }
            if (name.startsWith(query)) {
                return 1;
            }
            if (name.split(/\s+/).some((word) => word.startsWith(query))) {
                return 2;
            }
            return name.includes(query) ? 3 : 4;
        }));
        return { provider, score };
    })
        .filter(({ provider, score }) => score < 4 || normalizeProviderName(provider.description ?? "").includes(query))
        .sort((left, right) => left.score - right.score)
        .map(({ provider }) => provider);
};
exports.searchDafProviders = searchDafProviders;
const normalizeProviderName = (name) => name
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
